var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 26,
    viewBox: "0 0 118 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_2462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6819 15.1191C43.9932 15.1191 44.3138 15.1847 44.65 15.3159C44.983 15.4471 45.3067 15.622 45.618 15.8376H45.5993C45.9106 16.0531 46.1503 16.3468 46.3153 16.7185C46.4834 17.0903 46.5674 17.5151 46.5674 17.9962V20.4609C46.5674 21.4325 46.2437 22.1572 45.5993 22.6383C45.2881 22.8663 44.9706 23.0444 44.6406 23.1693C44.3107 23.2943 43.9932 23.3568 43.6819 23.3568H39.7754C39.4641 23.3568 39.1466 23.2943 38.8166 23.1693C38.4867 23.0444 38.1692 22.8663 37.8579 22.6383C37.2136 22.1603 36.8898 21.4325 36.8898 20.4609V19.2739C36.8898 18.7116 37.2416 18.4273 37.9482 18.4273C38.6548 18.4273 39.0221 18.7084 39.0221 19.2739V20.3172C39.0221 20.6296 39.1123 20.9108 39.2898 21.1638C39.4703 21.4168 39.7785 21.5418 40.2205 21.5418H43.2305C43.6725 21.5418 43.9838 21.4168 44.1612 21.1638C44.3418 20.9108 44.4289 20.6296 44.4289 20.3172V18.1399C44.4289 17.84 44.3387 17.562 44.1612 17.3027C43.9807 17.0465 43.6725 16.9153 43.2305 16.9153H39.7723C39.1497 16.9153 38.5116 16.6873 37.8548 16.2312C37.2104 15.7283 36.8867 15.0035 36.8867 14.0539V11.914C36.8867 11.4361 36.9708 11.0112 37.1389 10.6457C37.3069 10.2802 37.5435 9.98345 37.8548 9.75541H37.8361C38.1474 9.55236 38.468 9.38367 38.8042 9.25247C39.1372 9.12127 39.461 9.05566 39.7723 9.05566H43.6788C43.99 9.05566 44.3107 9.12127 44.6468 9.25247C44.9799 9.38367 45.3036 9.55236 45.6149 9.75541H45.5962C45.9075 9.98345 46.1472 10.2802 46.3122 10.6457C46.4803 11.0112 46.5643 11.4329 46.5643 11.914V12.9761C46.5643 13.5384 46.2063 13.8227 45.4904 13.8227C44.7745 13.8227 44.4321 13.5415 44.4321 12.9761V12.0765C44.4321 11.7766 44.3418 11.5017 44.1644 11.2486C43.9838 10.9956 43.6757 10.8706 43.2336 10.8706H40.2236C39.7816 10.8706 39.4703 10.9956 39.2929 11.2486C39.1123 11.5017 39.0252 11.7766 39.0252 12.0765V13.9102C39.0252 14.2226 39.1155 14.5006 39.2929 14.7474C39.4734 14.9941 39.7816 15.116 40.2236 15.116H43.6819V15.1191Z",
    fill: "url(#paint0_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7925 25.8531C49.3753 25.8531 49.1543 25.572 49.1294 25.0066C49.1294 24.4443 49.3504 24.16 49.7925 24.16H50.58C50.9971 24.16 51.2741 24.0351 51.4049 23.782L51.657 23.1166L51.7473 22.8292L48.2516 13.6388V13.6575C48.1551 13.3702 48.1769 13.1234 48.3139 12.9203C48.4509 12.7173 48.6625 12.5673 48.9489 12.4705C49.1637 12.4111 49.338 12.3799 49.4687 12.3799C49.8142 12.3799 50.029 12.5829 50.1131 12.9922L51.5294 16.5346L52.7309 19.4836L54.6484 13.0265C54.7573 12.5954 55.0063 12.3799 55.4017 12.3799C55.4982 12.3799 55.6538 12.4111 55.8686 12.4705C56.1549 12.5548 56.3604 12.6923 56.488 12.8828C56.6125 13.0734 56.6405 13.3014 56.5689 13.567C56.0304 15.4007 55.4857 17.2469 54.9285 19.1056C54.3744 20.9643 53.8266 22.8042 53.2881 24.6255C53.2289 24.7567 53.1356 24.891 53.0111 25.0316C52.8865 25.169 52.7216 25.3002 52.5192 25.4283C52.3169 25.5533 52.0648 25.6563 51.7659 25.7344C51.4671 25.8125 51.1216 25.85 50.7263 25.85H49.7956L49.7925 25.8531Z",
    fill: "url(#paint1_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0585 22.5821C60.0585 23.1569 59.7316 23.4443 59.0717 23.4443C58.4118 23.4443 58.085 23.1569 58.085 22.5821V15.3535C58.085 14.863 58.1628 14.435 58.3184 14.0758C58.4741 13.7166 58.72 13.4229 59.053 13.1949C59.6849 12.7388 60.3199 12.5107 60.9518 12.5107H63.8373C64.4474 12.5107 65.0793 12.7388 65.7361 13.1949C66.3805 13.651 66.7042 14.3694 66.7042 15.3535V22.5821C66.7042 23.1569 66.3774 23.4443 65.7175 23.4443C65.0576 23.4443 64.7307 23.1569 64.7307 22.5821V15.5159C64.7307 15.2035 64.6342 14.9036 64.4443 14.6162L64.463 14.635C64.3074 14.3476 63.9899 14.2039 63.5136 14.2039H61.2724C60.7837 14.2039 60.46 14.3476 60.3044 14.635C60.1363 14.888 60.0522 15.1817 60.0522 15.5159V22.5821H60.0585Z",
    fill: "url(#paint2_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3633 14.2011V20.7456C71.3633 21.058 71.4286 21.2986 71.5594 21.4641C71.6901 21.6328 71.9702 21.7172 72.4029 21.7172H72.8698C73.3367 21.7172 73.5577 21.9921 73.5328 22.545C73.5328 23.1073 73.3118 23.3916 72.8698 23.3916H72.2784C71.8955 23.3916 71.5376 23.3416 71.2045 23.2385C70.8683 23.1354 70.5477 22.9886 70.2364 22.798V22.8168C69.6512 22.4325 69.3586 21.7484 69.3586 20.7675V14.2042H68.6583C68.2287 14.2042 68.0015 13.9231 67.9766 13.3577C67.9766 12.7954 68.2038 12.5111 68.6583 12.5111H69.3586V10.5868C69.3586 10.012 69.6979 9.72461 70.3796 9.72461C71.0613 9.72461 71.3664 10.012 71.3664 10.5868V12.5111H72.8543C73.3212 12.5111 73.5422 12.7923 73.5173 13.3577C73.5173 13.92 73.2963 14.2042 72.8543 14.2042H71.3664L71.3633 14.2011Z",
    fill: "url(#paint3_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0633 22.5818C77.0633 23.1566 76.7334 23.444 76.0766 23.444C75.4198 23.444 75.0898 23.1566 75.0898 22.5818V9.81141C75.0898 9.23662 75.4198 8.94922 76.0766 8.94922C76.7334 8.94922 77.0633 9.23662 77.0633 9.81141V12.5073H80.8453C81.4554 12.5073 82.0873 12.7354 82.7441 13.1914C83.3885 13.6475 83.7122 14.366 83.7122 15.35V22.5787C83.7122 23.1535 83.3822 23.4409 82.7254 23.4409C82.0687 23.4409 81.7387 23.1535 81.7387 22.5787V15.5125C81.7387 15.2001 81.6422 14.9002 81.4523 14.6128L81.471 14.6315C81.3154 14.3441 80.9979 14.2004 80.5216 14.2004H77.0633V22.5818Z",
    fill: "url(#paint4_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4776 10.1741C88.4776 10.5583 88.3469 10.8832 88.0823 11.1456C87.8208 11.408 87.4971 11.5424 87.1142 11.5424C86.7314 11.5424 86.4077 11.4112 86.1368 11.1456C85.8691 10.8832 85.7322 10.5583 85.7322 10.1741C85.7322 9.78987 85.866 9.44937 86.1368 9.18384C86.4045 8.92144 86.7314 8.78711 87.1142 8.78711C87.4971 8.78711 87.8177 8.91831 88.0823 9.18384C88.3438 9.44625 88.4776 9.77738 88.4776 10.1741ZM88.101 22.5821C88.101 23.1569 87.771 23.4443 87.1142 23.4443C86.4575 23.4443 86.1119 23.1569 86.1119 22.5821V13.3042C86.1119 12.7294 86.445 12.442 87.1142 12.442C87.7835 12.442 88.101 12.7294 88.101 13.3042V22.5821Z",
    fill: "url(#paint5_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.842 10.8212L96.9166 22.9043V22.8856C96.845 23.0668 96.7454 23.2136 96.6209 23.3261C96.4964 23.4385 96.3439 23.4979 96.1633 23.4979C96.0668 23.4979 95.9766 23.4885 95.8863 23.4698C95.796 23.451 95.7026 23.4323 95.6093 23.4073H95.6279C94.9462 23.1917 94.6972 22.8075 94.8746 22.2577L98.9586 9.79658C99.0177 9.60602 99.1236 9.44358 99.273 9.31238C99.4224 9.18117 99.5967 9.10308 99.8021 9.07809C100.004 9.0406 100.204 9.01561 100.394 8.99686C100.583 8.97812 100.733 8.96875 100.842 8.96875C100.951 8.96875 101.1 8.97812 101.29 8.99686C101.48 9.01561 101.679 9.03435 101.881 9.05934C102.05 9.08433 102.211 9.17493 102.373 9.328C102.535 9.48419 102.657 9.64038 102.741 9.79658C103.41 11.8583 104.088 13.9357 104.773 16.0287C105.461 18.1217 106.137 20.1991 106.806 22.2608C106.974 22.8138 106.722 23.1949 106.053 23.4104C105.956 23.4354 105.869 23.4542 105.794 23.4729C105.716 23.4916 105.629 23.501 105.536 23.501C105.368 23.501 105.215 23.4448 105.078 23.3292C104.941 23.2167 104.842 23.0699 104.783 22.8887V22.9075L100.842 10.8243V10.8212ZM102.187 19.0214C102.187 19.4056 102.053 19.7305 101.785 20.0023C101.517 20.2709 101.19 20.4052 100.808 20.4052C100.425 20.4052 100.104 20.2709 99.8395 20.0023C99.578 19.7336 99.4442 19.4056 99.4442 19.0214C99.4442 18.6371 99.5749 18.3123 99.8395 18.0405C100.101 17.7718 100.425 17.6344 100.808 17.6344C101.19 17.6344 101.514 17.7687 101.785 18.0405C102.053 18.3091 102.187 18.6371 102.187 19.0214Z",
    fill: "url(#paint6_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.625 22.5826C110.625 23.1574 110.267 23.4448 109.552 23.4448C108.836 23.4448 108.493 23.1574 108.493 22.5826V9.83094C108.493 9.25615 108.845 8.96875 109.552 8.96875C110.258 8.96875 110.625 9.25615 110.625 9.83094V22.5795V22.5826Z",
    fill: "url(#paint7_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.417 19.2962C25.4473 17.4312 26.0356 15.2851 26.0356 13.0016C26.0325 5.81978 20.2335 0 13.0803 0C5.9303 0 0.125 5.82602 0.125 13.0016C0.125 20.1802 5.92408 26.0031 13.0803 26.0031C15.4522 26.0031 17.6748 25.3627 19.586 24.2475L24.2614 25.6876C25.2512 25.9938 26.1819 25.0628 25.8769 24.0663L24.417 19.2962Z",
    fill: "url(#paint8_linear_823_2462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0548 8.33422C14.0548 7.79421 13.6186 7.35645 13.0805 7.35645C12.5424 7.35645 12.1062 7.79421 12.1062 8.33422V17.6684C12.1062 18.2084 12.5424 18.6461 13.0805 18.6461C13.6186 18.6461 14.0548 18.2084 14.0548 17.6684V8.33422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88023 10.1741C9.88023 9.63405 9.44402 9.19629 8.90594 9.19629C8.36785 9.19629 7.93164 9.63405 7.93164 10.1741V15.3847C7.93164 15.9247 8.36785 16.3625 8.90594 16.3625C9.44402 16.3625 9.88023 15.9247 9.88023 15.3847V10.1741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7064 11.758C5.7064 11.218 5.2702 10.7803 4.73211 10.7803C4.19402 10.7803 3.75781 11.218 3.75781 11.758V13.8448C3.75781 14.3848 4.19402 14.8226 4.73211 14.8226C5.2702 14.8226 5.7064 14.3848 5.7064 13.8448V11.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2809 15.3601C16.2809 15.9001 16.7171 16.3379 17.2552 16.3379C17.7933 16.3379 18.2295 15.9001 18.2295 15.3601V10.1495C18.2295 9.60949 17.7933 9.17172 17.2552 9.17172C16.7171 9.17172 16.2809 9.60949 16.2809 10.1495V15.3601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4516 13.7791C20.4516 14.3191 20.8878 14.7568 21.4259 14.7568C21.9639 14.7568 22.4001 14.3191 22.4001 13.7791V11.6923C22.4001 11.1523 21.9639 10.7145 21.4259 10.7145C20.8878 10.7145 20.4516 11.1523 20.4516 11.6923V13.7791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.844 20.605C101.685 20.605 102.367 19.921 102.367 19.0774C102.367 18.2337 101.685 17.5498 100.844 17.5498C100.004 17.5498 99.3223 18.2337 99.3223 19.0774C99.3223 19.921 100.004 20.605 100.844 20.605Z",
    fill: "#29185E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_2462",
    x1: 49.9432,
    y1: 20.7486,
    x2: 44.0532,
    y2: 25.5675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_823_2462",
    x1: 59.5422,
    y1: 23.396,
    x2: 54.0976,
    y2: 27.5061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_823_2462",
    x1: 69.7099,
    y1: 21.4503,
    x2: 65.1211,
    y2: 25.8225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_823_2462",
    x1: 75.473,
    y1: 20.8991,
    x2: 70.9261,
    y2: 23.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_823_2462",
    x1: 86.719,
    y1: 20.8005,
    x2: 80.9456,
    y2: 24.9514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_823_2462",
    x1: 89.435,
    y1: 20.7712,
    x2: 86.7824,
    y2: 21.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_823_2462",
    x1: 111.054,
    y1: 20.8507,
    x2: 104.948,
    y2: 26.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_823_2462",
    x1: 111.369,
    y1: 20.8047,
    x2: 109.27,
    y2: 21.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_823_2462",
    x1: 35.0712,
    y1: 21.2608,
    x2: 24.3311,
    y2: 34.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_2462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 26,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09e51b85948e8ce94e78287429a47e42.svg";
export { ForwardRef as ReactComponent };